// src/modules/purityAnalyzer/hooks/useBranchScope.js
// Determines whether the current user has HO/global visibility (sees all
// branches) — same rule the backend scopeBranch middleware applies. Also
// provides the branch list for the HO branch-filter dropdown.

import { useEffect, useState } from 'react';
import { useAuth } from '../../../context/AuthContext';
import { isGlobalViewer } from '../../../constants/roles';
import { fetchBranchById } from '../../branches/api';
import { fetchBranchList } from '../api';

export default function useBranchScope() {
  const { user } = useAuth();
  const [isHO, setIsHO] = useState(false);
  const [branches, setBranches] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const globalRole = isGlobalViewer(user);
        let ho = globalRole;
        if (!ho && user?.branch) {
          const res = await fetchBranchById(user.branch);
          const branch = res?.data || res;
          ho = branch?.branchType === 'HO';
        }
        if (!mounted) return;
        setIsHO(ho);
        if (ho) {
          const listRes = await fetchBranchList();
          // GET /branches → { success, data: [branches], pagination }
          const items = listRes?.data?.data || [];
          if (mounted) setBranches(Array.isArray(items) ? items : []);
        }
      } catch {
        // Fail closed: treat as branch-scoped user.
      } finally {
        if (mounted) setLoading(false);
      }
    })();
    return () => { mounted = false; };
  }, [user]);

  return { isHO, branches, loading };
}
